import { render } from "./Illustration1.vue?vue&type=template&id=87f6fc1a&scoped=true"
import script from "./Illustration1.vue?vue&type=script&lang=js"
export * from "./Illustration1.vue?vue&type=script&lang=js"

import "./Illustration1.vue?vue&type=style&index=0&id=87f6fc1a&lang=css&scoped=true"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-6763a87ef6/0/cache/vue-loader-npm-17.4.2-00674d01e5-ffbe3e848e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f6fc1a"]])

export default __exports__